<template>
  <ul class="sub-navigation">
    <NavigationItem
      v-for="route in routes.items"
      :key="route.link.value.text"
      class="sub-navigation__item"
    >
      <span
        v-if="route.link.value.code"
        class="sub-navigation__link"
        :class="{ active: route.link.value.code === currentLocale }"
        @click="setLocale(route.link.value.code)"
      >
        {{ route.link.value.text }}
      </span>
      <ShLink
        v-else
        class="sub-navigation__link"
        :to="route.link.value.href"
        :target="route.link.value.target"
      >
        {{ route.link.value.text }}
      </ShLink>
    </NavigationItem>
  </ul>
</template>

<script>
import { NavigationItem } from '@sohohouse/design-system'

import ShLink from '~/components/sh-link'

export default {
  name: 'MobileSubNav',

  components: {
    NavigationItem,
    ShLink
  },

  props: {
    routes: {
      type: Object,
      required: true
    }
  },

  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },

  methods: {
    setLocale (code) {
      this.$i18n.setLocaleCookie(code)
      this.$router.push(this.switchLocalePath(code))
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-navigation {
  margin-top: $space-060;
  margin-left: $space-070;
  margin-right: $space-060;
  padding: 0;

  &__item {
    margin-bottom: $space-070;
  }

  &__link {
    @include font('060');
    @include underline(transparent);

    &.active {
      border-bottom-color: inherit;
    }
  }
}
</style>
